import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Modal, Form, Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { Map, List } from 'immutable';
import Noty from 'noty';
import classNames from 'classnames';
import { format } from 'date-fns';
import { getUsers, getUsersDismiss, retrieveDownloadRules } from '../../actions/userList';
import { retrieveWorkspaceInfo, workspaceUnsubscribe } from '../../actions/workspaces';
import Button from '../ui/Button';
import Loader from '../ui/Loader';
import CloseIcon from '../Icons/CloseIcon';
import appConfig from '../../appConfig';
import { DATE_FORMAT } from '../../constants/session';

const mapStateToProps = state => ({
  userList: state.userList,
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  getUserList: () =>
    dispatch(getUsers(true)),
  onUserDismiss: () =>
    dispatch(getUsersDismiss()),
  getWorkspaceInfo: workspaceID =>
    dispatch(retrieveWorkspaceInfo(workspaceID)),
  unsubscribeUser: workspaceID =>
    dispatch(workspaceUnsubscribe(workspaceID)),
  retrieveDownloadRules: () =>
    dispatch(retrieveDownloadRules()),
});

/* eslint react/no-find-dom-node: 0 */
/* this rule was disabled for page because it's the recommended way to get
  ref values for react bootstrap inputs (all ReactDOM.findDOMNode lines) */
class WorkspaceDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      name: props.selectedWorkspaceData ? props.selectedWorkspaceData.name : '',
      description: props.selectedWorkspaceData && props.isEditMode ?
        props.selectedWorkspaceData.description : '',
      expiryDate: null,
      isOwner: false,
      ownerName: '',
      downloadRule: '',
      downRuleName: '',
      downloadRulesList: [],
      subscribed: false,
      securityLevel: false,
      selectedUsers: [],
      users: [],
      userList: props.userList,
      errMsg: '',
    };

    this.nameInput = null;
    this.descriptionInput = null;
    this.usersInput = null;
    this.dateFormat = appConfig.dateFormat || DATE_FORMAT;

    this.setUserList = this.setUserList.bind(this);
    this.setDownloadRules = this.setDownloadRules.bind(this);
    this.onUsersChange = this.onUsersChange.bind(this);
    this.onUsersRemove = this.onUsersRemove.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onUnsubscribeSubmit = this.onUnsubscribeSubmit.bind(this);
    this.onDownloadRuleChange = this.onDownloadRuleChange.bind(this);
    this.onClose = this.onClose.bind(this);
    this.renderOwnerSettings = this.renderOwnerSettings.bind(this);
    this.displayError = this.displayError.bind(this);
  }

  componentDidMount() {
    if (this.props.isEditMode) {
      this.props.getWorkspaceInfo(this.props.selectedWorkspaceData.id)
        .then((res) => {
          this.setState({
            users: res.users,
            isOwner: res.isOwner,
            ownerName: res.ownerName,
            expiryDate: res.expiryDate ? new Date(res.expiryDate) : null,
            securityLevel: res.security,
            downRuleName: res.downRuleName,
          });
          return res;
        })
        .then((res) => {
          if (!this.props.userList.get('downloadRules') && res.isOwner) {
            this.props.retrieveDownloadRules().then(() => {
              this.setDownloadRules(res && res.downloadRule);
            });
          } else if (res.isOwner) {
            this.setDownloadRules(res && res.downloadRule);
          }
          return res;
        })
        .then((res) => {
          if (!this.props.userList.get('userList') && res.isOwner) {
            this.props.getUserList()
              .then(resData => this.setUserList(resData, res.users));
          } else if (res.isOwner) {
            this.setUserList(this.props.userList.get('userList'), res.users);
          }
        });
    }
  }

  onUsersChange(value) {
    this.setState({ selectedUsers: value });
  }

  onDownloadRuleChange(value) {
    this.setState({ downloadRule: value });
  }

  onUsersRemove(e) {
    e.preventDefault();
    this.setState({ selectedUsers: [] });
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.setState({ isSubmitting: true });

    let usersValue = [];
    let removeUsersValue = [];
    if (this.props.isEditMode) {
      // add users array
      usersValue = _.map(this.state.selectedUsers,
        user => (user.value ? user.value.toUpperCase() : user.toUpperCase()));

      // always add logged in user
      usersValue.push(this.props.username.toUpperCase());

      // remove users array
      removeUsersValue = _.filter(this.state.users,
        el => usersValue.indexOf(el.toUpperCase()) < 0);

      this.props.onEditSubmit(
        this.props.selectedWorkspaceData.id,
        this.state.name,
        this.state.description,
        usersValue,
        removeUsersValue,
        this.state.expiryDate ? format(this.state.expiryDate, 'yyyy-MM-dd') : '',
        this.state.securityLevel,
        this.state.downloadRule ? this.state.downloadRule.value : '',
      )
        .then((res) => {
          if (res.res && res.res.s && res.res.s.s === 'T') {
            this.onClose();
          } else {
            this.displayError(res);
          }
        })
        .catch(error => this.displayError(error));
    } else {
      this.props.onCreateSubmit(
        // parent id needs to be undefined to default to root. null won't work
        this.props.selectedWorkspaceData ? this.props.selectedWorkspaceData.id : undefined,
        this.state.name,
        this.state.description,
      )
        .then((res) => {
          if (res.res && res.res.s && res.res.s.s === 'T') {
            this.onClose();
          } else {
            this.displayError(res);
          }
        })
        .catch(error => this.displayError(error));
    }
  }

  onDeleteSubmit() {
    const n = new Noty({
      theme: 'bootstrap-v4',
      timeout: false,
      type: 'info',
      text: this.props.intl.formatMessage({ id: 'workspaceDialog.deleteWorkspace' }),
      layout: 'center',
      buttons: [
        Noty.button(this.props.intl.formatMessage({ id: 'workspaceDialog.deleteButton' }),
          'btn btn-primary', () => {
            this.props.onDeleteSubmit(this.props.selectedWorkspaceData.id);
            n.close();
            this.onClose();
          }, { id: 'button1', 'data-status': 'ok' }),
        Noty.button(this.props.intl.formatMessage({ id: 'workspaceDialog.cancelButton' }),
          'btn btn-error', () => {
            n.close();
          }),
      ],
    });
    n.show();
  }

  onUnsubscribeSubmit() {
    const n = new Noty({
      theme: 'bootstrap-v4',
      timeout: false,
      type: 'info',
      text: this.props.intl.formatMessage({ id: 'workspaceDialog.unsubscribeFromWS' }),
      layout: 'center',
      buttons: [
        Noty.button(this.props.intl.formatMessage({ id: 'workspaceDialog.unsubscribeButton' }),
          'btn btn-primary', () => {
            this.props.unsubscribeUser(this.props.selectedWorkspaceData.id);
            n.close();
            this.onClose();
          }, { id: 'button1', 'data-status': 'ok' }),
        Noty.button(this.props.intl.formatMessage({ id: 'workspaceDialog.cancelButton' }),
          'btn btn-error', () => {
            n.close();
          }),
      ],
    });
    n.show();
  }

  onClose() {
    this.props.onDialogClose();
  }

  setUserList(fullUserList, selectedUserList) {
    const filterSelectedUsers = _.filter(fullUserList,
      user => user._.toUpperCase() !== this.props.username.toUpperCase() &&
        _.includes(selectedUserList, user._));
    const selectedUsers = _.map(filterSelectedUsers,
      usr => ({ value: usr._, label: usr.$ ? `${usr.$.fn || usr.$.n} (${usr._})` : usr._ }));

    this.setState({
      userList: fullUserList,
      selectedUsers,
    });
  }

  setDownloadRules(downRule) {
    let selectedRule = this.state.downloadRule;
    const downRuleOptions = Array.isArray(this.props.userList.get('downloadRules')) ?
      _.map(this.props.userList.get('downloadRules'), (rule) => {
        if (rule._ === downRule) {
          selectedRule = { value: rule._, label: rule.$ ? rule.$.ret : rule._ };
        }
        return ({ value: rule._, label: rule.$ ? rule.$.ret : rule._ });
      }) : [];

    this.setState({
      downloadRulesList: downRuleOptions,
      downloadRule: selectedRule,
    });
  }

  displayError(errMsg) {
    this.setState({
      errMsg: (errMsg.message && errMsg.message.includes('A Lightbox with this name already exists')) ?
        `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.nameExists` :
        `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.errorOccurred`,
      isSubmitting: false,
    });
  }

  renderOwnerSettings() {
    if (this.props.isEditMode && !this.props.isHighlight) {
      return (<div>
        <Form.Group className="workspace-dialog__form-date form-group form-group">
          <label htmlFor="workspace-dialog__form-date">
            {this.props.intl.formatMessage({ id: 'workspaceDialog.expiryLabel' })}
          </label>
          {this.state.isOwner ?
            <div>
              <button
                type="button"
                className="react-datepicker__close-icon workspace-dialog__form-date-remove"
                aria-label="Clear"
                tabIndex="-1"
                onClick={() => this.setState({ expiryDate: null })}
              />
              <DatePicker
                isClearable
                className="workspace-detail-view__content-date-edit"
                disabled={this.state.isSubmitting}
                value={this.state.expiryDate ? format(this.state.expiryDate, this.dateFormat) : ''}
                onChange={date => this.setState({ expiryDate: date || null })}
                placeholderText={this.dateFormat.toLocaleLowerCase()}
                dateFormat={this.dateFormat}
              />
            </div> :
            <Form.Text className="text-muted">
              {this.state.expiryDate ? format(this.state.expiryDate, this.dateFormat) : ''}
            </Form.Text>
          }
        </Form.Group>
        {this.state.isOwner ?
          <Form.Group className="workspace-dialog__form-security form-group">
            <label htmlFor="workspace-dialog__form-security">
              {this.props.intl.formatMessage({ id: 'workspaceDialog.sharingSecurityLabel' })}
            </label>
            <Form.Check // prettier-ignore
              type="switch"
              id="workspace-dialog__form-security-check"
              className="workspace-dialog__form-security-check"
              label={this.props.intl.formatMessage({ id: 'workspaceDialog.sharingSecurityCheckbox' })}
              disabled={this.state.isSubmitting}
              checked={this.state.securityLevel}
              onChange={() => this.setState({ securityLevel: !this.state.securityLevel })}
            />
            <Form.Text className="text-muted">
              {this.props.intl.formatMessage({ id: 'workspaceDialog.sharingSecurityHelper' })}
            </Form.Text>
          </Form.Group>
          : null}
      </div>);
    }
    return null;
  }

  render() {
    const { intl } = this.props;
    let downloadRules;
    // Set user options for share tool
    let listUsers = [];
    if (this.props.isEditMode && !this.props.isHighlight) {
      const userOptions = _.map(this.state.userList, (user) => {
        if (user && user !== this.props.username) {
          return ({ value: user._, label: user.$ ? `${user.$.fn || user.$.n} (${user._})` : '' });
        }
      });

      listUsers = this.props.isEditMode && this.state.isOwner ? (
        <Form.Group className="workspace-dialog__form-users form-group">
          <label htmlFor="workspace-dialog__form-users">
            {intl.formatMessage({ id: 'workspaceDialog.shareLabel' })}
            <button
              className="workspace-dialog__form-users-remove"
              onClick={this.onUsersRemove}
            >
              <i />
              {intl.formatMessage({ id: 'workspaceDialog.shareRemoveAll' })}
            </button>
          </label>
          <Select
            value={this.state.selectedUsers}
            isMulti
            isSearchable
            onChange={this.onUsersChange}
            name="users"
            options={userOptions}
            className="workspace-dialog__form-users-select"
            openOnFocus
            closeOnSelect
            placeholder={this.props.intl.formatMessage({ id: 'general.select' })}
          />
        </Form.Group>
      ) : null;

      if (this.props.isEditMode && this.state.isOwner) {
        downloadRules = (
          <Form.Group className="workspace-dialog__form-downrule form-group">
            <label htmlFor="workspace-dialog__form-downrule">
              {intl.formatMessage({ id: 'workspaceDialog.downloadRuleList' })}
            </label>
            {this.state.downloadRulesList.length > 0 ?
              <Select
                value={this.state.downloadRule}
                isSearchable
                onChange={this.onDownloadRuleChange}
                name="users"
                options={this.state.downloadRulesList}
                className="workspace-dialog__form-downrule-select"
                openOnFocus
                closeOnSelect
                placeholder={intl.formatMessage({ id: 'general.select' })}
              />
              : (<Form.Text className="text-muted">
                {this.props.intl.formatMessage({ id: 'workspaceDialog.downloadRuleListEmpty' })}
              </Form.Text>)}
          </Form.Group>
        );
      } else if (this.props.session.get('acctType') === 'P') { // only display for portal users
        downloadRules = (<div>
          <label htmlFor="workspace-dialog__form-downrule">
            {intl.formatMessage({ id: 'workspaceDialog.downloadRuleSetting' })} {this.state.downRuleName}
          </label>
          <Form.Text className="text-muted">
            {intl.formatMessage({ id: 'workspaceDialog.downloadRuleSettingHelper' })}
          </Form.Text>
        </div>);
      }
    }

    const deleteButton = this.state.isOwner ?
      (<Button
        variant="danger"
        onClick={this.onDeleteSubmit}
        className="workspace-dialog__delete-button"
        disabled={this.state.isSubmitting}
      >
        {intl.formatMessage({ id: 'workspaceDialog.deleteButton' })}
      </Button>)
      :
      (<Button
        variant="danger"
        onClick={this.onUnsubscribeSubmit}
        className="workspace-dialog__delete-button"
        disabled={this.state.isSubmitting}
      >
        {intl.formatMessage({ id: 'workspaceDialog.unsubscribeButton' })}
      </Button>);

    const dialogType = this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog';

    return (
      <div className="workspace-dialog">
        <Modal
          show
          onHide={this.onClose}
          dialogClassName={classNames('workspace-dialog__overlay', {
            'workspace-dialog__overlay--edit': this.props.isEditMode && !this.props.isHighlight,
          })}
        >
          <CloseIcon
            width={24}
            height={24}
            onClick={this.onClose}
            className="workspace-dialog__close-button"
          />
          <div className="workspace-dialog__form">
            <div className="workspace-dialog__form-header">
              {intl.formatMessage({
                id: `${dialogType}.${this.props.isEditMode ?
                  'editWorkspaceHeader' : 'addWorkspaceHeader'}`
              })}
              <div className="workspace-dialog__form-header-sub">
                {this.props.selectedWorkspaceData ? this.props.selectedWorkspaceData.name : ''}
              </div>
              <div className="workspace-dialog__form-header-sub">
                {this.props.isEditMode && !this.props.isHighlight ? `${intl.formatMessage({ id: 'workspaceDialog.ownerLabel' })} ${this.state.ownerName}` : null}
              </div>
            </div>
            <Form onSubmit={this.onFormSubmit}>
              <div className="row col-sm-12">
                <Col className={classNames({ 'col-sm-6': this.props.isEditMode && !this.props.isHighlight })}>
                  <Form.Group className="workspace-dialog__form-name form-group">
                    <label htmlFor="workspace-dialog__form-name">
                      {intl.formatMessage({ id: 'workspaceDialog.nameLabel' })}
                    </label>
                    <Form.Control
                      type="text"
                      disabled={this.state.isSubmitting}
                      placeholder={intl.formatMessage({
                        id: `${dialogType}.namePlaceholder`
                      })}
                      value={this.state.name}
                      onChange={e => this.setState({ name: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group className="workspace-dialog__form-description form-group">
                    <label htmlFor="workspace-dialog__form-description">
                      {intl.formatMessage({ id: 'workspaceDialog.descriptionLabel' })}
                    </label>
                    <Form.Control
                      disabled={this.state.isSubmitting}
                      as="textarea"
                      placeholder={intl.formatMessage({ id: 'workspaceDialog.descriptionPlaceholder' })}
                      value={this.state.description}
                      onChange={e => this.setState({ description: e.target.value })}
                    />
                  </Form.Group>
                  {this.renderOwnerSettings()}
                </Col>
                {this.props.isEditMode && !this.props.isHighlight ?
                  <Col xs="6">
                    {downloadRules}
                    {listUsers}
                  </Col>
                  : null}
              </div>
              <div className="form-group">
                <label className="workspace-dialog__err-msg">
                  {this.state.errMsg ? intl.formatMessage({ id: this.state.errMsg }) : null}
                </label>
              </div>
              <div className="form-group">
                <Button
                  type="submit"
                  className="workspace-dialog__save-button btn-primary btn-sm"
                  disabled={this.state.isSubmitting}
                >
                  {this.state.isSubmitting ? <Loader /> :
                    intl.formatMessage({ id: `workspaceDialog.${this.props.isEditMode ? 'saveButton' : 'createButton'}` })}
                </Button>
                {
                  this.props.isEditMode ? deleteButton : null}
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

WorkspaceDialog.propTypes = {
  userList: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  onDialogClose: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  unsubscribeUser: PropTypes.func,
  retrieveDownloadRules: PropTypes.func,
  getUserList: PropTypes.func,
  getWorkspaceInfo: PropTypes.func,
  isEditMode: PropTypes.bool,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    users: PropTypes.instanceOf(List),
  }),
  username: PropTypes.string,
  isHighlight: PropTypes.bool,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(WorkspaceDialog));
